import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenericResModel } from 'countable@model';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CacheFlowService {

  private static readonly GET_CASH_FLOW_LEFT = environment.apiV1 + '/cf-left';
  private static readonly GET_CASH_FLOW = environment.apiV1 + '/cf';
  private static readonly GET_CASH_FLOW_MIDDLE = environment.apiV1 + '/cf-middle';
  private static readonly GET_CASH_FLOW_REPORT = environment.apiV1 + '/cf-report';
  private static readonly SAVE_PREVIEW_CASH_FLOW_TYPE = environment.apiV1 + '/preview-cf-type';
  private static readonly SAVE_ADD_CASH_FLOW = environment.apiV1 + '/cf-add';
  private static readonly SAVE_ADD_CASH_FLOW_AMOUNT = environment.apiV1 + '/cf-add-amount';

  constructor(private http: HttpClient) {}

  getCFLeft(engId: number, year: number): Observable<string> {
    return this.http.get<string>(CacheFlowService.GET_CASH_FLOW_LEFT, {params: {'engId': engId, 'year': year}});
  }

  getCacheFlow(engId: number, year: number): Observable<string> {
    return this.http.get<string>(CacheFlowService.GET_CASH_FLOW, {params: {'engId': engId, 'year': year}});
  }

  getCFMiddle(engId: number, year: number): Observable<string> {
    return this.http.get<string>(CacheFlowService.GET_CASH_FLOW_MIDDLE, {params: {'engId': engId, 'year': year}});
  }

  getCFReport(engId: number, year: number): Observable<GenericResModel<string>> {
    return this.http.get<GenericResModel<string>>(CacheFlowService.GET_CASH_FLOW_REPORT, {
      params: {
        'engId': engId,
        'year': year
      }
    });
  }

  savePreviewCFType(data: string): Observable<GenericResModel<boolean>> {
    return this.http.post<GenericResModel<boolean>>(CacheFlowService.SAVE_PREVIEW_CASH_FLOW_TYPE, data);
  }

  saveAddCashFlow(data: string): Observable<GenericResModel<boolean>> {
    return this.http.post<GenericResModel<boolean>>(CacheFlowService.SAVE_ADD_CASH_FLOW, data);
  }

  saveAddCFAmount(data: string): Observable<GenericResModel<boolean>> {
    return this.http.post<GenericResModel<boolean>>(CacheFlowService.SAVE_ADD_CASH_FLOW_AMOUNT, data);
  }
}
